import type { RouteIdType } from './routes';
import { RouteId } from './routes';

const cardRoutes = new Set<string>([RouteId.CARD]);

export const isCardRoute = (routeId: RouteIdType): boolean =>
  cardRoutes.has(routeId);
